/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'links.scss' instead.
import { css } from 'lit';
export default css `:host a:not(:visited):not(:focus):not(:hover):not(:active){border-bottom:.5px solid var(--cipublic-border-inverted-color)}:host([class*=inverted]) a:focus{background:var(--cipublic-color-gray-300);color:var(--cipublic-color-gray-900)}:host([class*=inverted]) a:focus-visible{outline:0}`;
//# sourceMappingURL=links.scss.js.map